/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { Toaster } from "@/components/ui/sonner";
import "@/public/styles/globals.css";
import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import Layout from "./components/layout";

// pages
const DeviceMqttURLPage = lazy(() => import("./app/devices/mqtt-url"));
const Home = lazy(() => import("./app/Home"));
const MQTTPage = lazy(() => import("./app/playground/MQTT"));
const DeviceAuthPage = lazy(() => import("./app/devices/auth"));
const DeviceAuthHistoryPage = lazy(() => import("./app/devices/authHistory"));
const UserListPage = lazy(() => import("./app/user/list"));
const TRVProgrammingPage = lazy(() => import("./app/Programming/TRVProgramming/Page"));
const ThermostatProgrammingPage = lazy(() => import("./app/Programming/ThermostatProgramming/Page"));

const elem = document.getElementById("root");
const app = (
  <StrictMode>
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/devices/mqtt-url" element={<DeviceMqttURLPage />} />
            <Route
              path="/devices/authHistory"
              element={<DeviceAuthHistoryPage />}
            />
            <Route path="/playground/mqtt" element={<MQTTPage />} />
            <Route path="/devices/auth" element={<DeviceAuthPage />} />
            <Route path="/user/list" element={<UserListPage />} />
            <Route path="/programming/trv" element={<TRVProgrammingPage />} />
            <Route path="/programming/thermostat" element={<ThermostatProgrammingPage />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
    <Toaster richColors />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
